/* istanbul ignore file */
/**
 * Created by gboue on 8/24/22
 * File: DomainVerificationTypeRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useMemo, VFC } from 'react'
import { Body } from '@panwds/react-ui'
import type { RowInstance } from '@panwds/react-table'
import { IDP_OWNER_TYPES } from '../../../../../constants/IAMConstants'
import { LABEL_DNS_VERIFICATION, LABEL_OWNER_GRANT } from '../../../../../constants/LabelConstants'

/**
  *   Domain Verification table cell
  */
const DomainVerificationTypeRenderer: VFC<{
  row: RowInstance<any>,
  value: 'dns_txt' | 'owner_grant'
}> = ({ row, value }) => {

  const map: Record<'dns_txt' | 'owner_grant', string> = useMemo(() => ({
    [IDP_OWNER_TYPES.DNS_TEXT]: LABEL_DNS_VERIFICATION,
    [IDP_OWNER_TYPES.OWNER_GRANT]: LABEL_OWNER_GRANT,
  }), [])

  const label = useMemo(() => map[value], [map, value])

  return (
    <Body size="lg" addClassName='tw-truncate'>{label}</Body>
  )
}

DomainVerificationTypeRenderer.propTypes = {}
export default DomainVerificationTypeRenderer
